import { ModalOverlay } from 'cio-design-library/client-components'
import {
  ButtonContainer,
  CloseIcon,
  CloseIconWrapper,
  Container,
  Content,
  UnlockFeaturesContainer,
  ModalTitle,
  GotItRightContainer,
  HelpImproveContainer,
  FeatureTitle,
  NoCompletedIcon,
  WarningImage,
  CompletedIcon,
  FeatureItem,
  AIModalTitleContainer,
} from './styles'
import { ButtonV2 } from 'builder/components/Button'
import { i18n as I18n } from 'builder/utils/i18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { FetchStatuses } from 'builder/modules/constants'

// images
import warningIcon from 'images/builder/ai-review-modal/warning.svg'
import noCompleteIcon from 'images/builder/ai-review-modal/no_complete.svg'
import allCompleteIcon from 'images/builder/ai-review-modal/all_complete.svg'

type ModalAIReviewResultProps = {
  showModal: (value: boolean) => void
  triggerAIReviewHightlight: () => void
}

const ModalAIReviewResult = ({
  showModal,
  triggerAIReviewHightlight,
}: ModalAIReviewResultProps) => {
  const reviewResult = useTypedSelector(state => state.resumeEditor.aiResumeReview.reviewResult)
  const fetchStatus = useTypedSelector(state => state.resumeEditor.aiResumeReview.fetchStatus)

  const getNelements = (result: string, numberOfElements: number) => {
    if (!result) return []
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = result

    const elements = tempDiv.getElementsByTagName('li')
    if (elements.length > 0) return Array.from(elements).slice(0, numberOfElements)
    return []
  }

  const handleClose = () => {
    showModal(false)
  }

  const handleImproveCV = () => {
    showModal(false)
    triggerAIReviewHightlight()
  }

  return (
    <>
      {fetchStatus === FetchStatuses.loaded && (
        <ModalOverlay onClose={handleClose}>
          <Container>
            <Content>
              <FeatureTitle>{I18n.t(`builder.ai_review_modal.ai_review_complete`)}</FeatureTitle>
              <AIModalTitleContainer>
                <WarningImage src={warningIcon} />
                <ModalTitle>{I18n.t(`builder.ai_review_modal.your_resume_needs_work`)}</ModalTitle>
              </AIModalTitleContainer>
            </Content>

            <UnlockFeaturesContainer>
              {reviewResult?.topStrengths && reviewResult.topStrengths.length > 0 && (
                <>
                  <FeatureTitle>{I18n.t(`builder.ai_review_modal.you_got_it_right`)}</FeatureTitle>
                  <GotItRightContainer>
                    {getNelements(reviewResult?.topStrengths, 2).map((element, index) => {
                      return (
                        <FeatureItem key={index}>
                          <CompletedIcon src={allCompleteIcon} />
                          <span>{element.textContent}</span>
                        </FeatureItem>
                      )
                    })}
                  </GotItRightContainer>
                </>
              )}

              {reviewResult?.quickTips && reviewResult.quickTips.length > 0 && (
                <>
                  <FeatureTitle>{I18n.t(`builder.ai_review_modal.how_we_will_help`)}</FeatureTitle>
                  <HelpImproveContainer>
                    {getNelements(reviewResult?.quickTips, 3).map((element, index) => {
                      return (
                        <FeatureItem key={index}>
                          <NoCompletedIcon src={noCompleteIcon} />
                          <span>{element.textContent}</span>
                        </FeatureItem>
                      )
                    })}
                  </HelpImproveContainer>
                </>
              )}
            </UnlockFeaturesContainer>
            <ButtonContainer>
              <ButtonV2 onClick={handleImproveCV} style={{ width: '100%' }}>
                {I18n.t(`builder.ai_review_modal.cta`)}
              </ButtonV2>
            </ButtonContainer>
            <CloseIconWrapper showHoverState={true} onClick={handleClose}>
              <CloseIcon />
            </CloseIconWrapper>
          </Container>
        </ModalOverlay>
      )}
    </>
  )
}

export default ModalAIReviewResult
